import {USER_ROLES} from "../../utilities/enums";

const Authentication = {
  state: {
    expirationTime: null,
    userInfo: {name: null, id: null, roles: null, email: null},
    hasConsented: false,
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.expirationTime = Date.now() + 60 * 60 * 1000; // expire after 1 hour
      state.userInfo.name = userInfo.username;
      state.userInfo.id = userInfo.userId;
      state.userInfo.roles = userInfo.roles;
      state.userInfo.email = userInfo.email;
    },
    setExpirationTime(state) {
      state.expirationTime = Date.now() + 60 * 60 * 1000;
    },
    setHasConsented(state, value) {
      state.hasConsented = value;
    },
  },
  getters: {
    getTokenExpirationTime: (state) => {
      return state.expirationTime;
    },
    getUserInfo: (state) => {
      return state.userInfo;
    },
    isAdmin: (state) => {
      if (state.userInfo.roles == null) return false;
      else return state.userInfo.roles.some((role) => role == USER_ROLES.ADMIN);
    },
    hasConsented: (state) => {
      return state.hasConsented;
    },
  },
};
export default Authentication;
